
export default {
	name: 'am-ul',
}
